import { styled } from '../theme';
import ListItem from './ListItem';

const ListItemBottom = styled(ListItem)(({ theme }) => ({
    fontWeight: 'bold',
    borderTop: theme.border.tableRowSeparator,
    borderRadius: 0,
    borderBottomLeftRadius: theme.borderRadius.base,
    borderBottomRightRadius: theme.borderRadius.base,
}));

export default ListItemBottom;
